import { z } from 'zod';

import { SAFE_URL_PROTOCOL } from './url.js';

const jsonString = z.string().transform((val, ctx) => {
  try {
    return JSON.parse(val);
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid JSON string',
    });
    return z.NEVER;
  }
});

export function jsonEncoded<T extends z.ZodTypeAny>(schema: T) {
  return jsonString.pipe(schema);
}

/**
 * A trimmed string that accepts either an empty value or a valid URL with a
 * safe scheme (see {@link SAFE_URL_PROTOCOL}). Useful for optional URL fields
 * in forms where the user may leave the input blank; rejecting `javascript:` /
 * `data:` keeps a stored value safe to render into an anchor href.
 */
export const optionalUrl = (message = 'Must be a valid URL') =>
  z
    .string()
    .trim()
    .pipe(
      z.union([
        z.literal(''),
        z.url({ protocol: SAFE_URL_PROTOCOL, error: message }),
      ]),
    );
